import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link', 'text', 'input'];

  connect() {
    this.dragCounter = 0;
    this._originalText = this.hasTextTarget ? this.textTarget.textContent : '';

    this._onDragEnter = this._onDragEnter.bind(this);
    this._onDragLeave = this._onDragLeave.bind(this);
    this._onDragOver  = this._onDragOver.bind(this);
    this._onDrop      = this._onDrop.bind(this);

    document.addEventListener('dragenter', this._onDragEnter);
    document.addEventListener('dragleave', this._onDragLeave);
    document.addEventListener('dragover',  this._onDragOver);
    document.addEventListener('drop',      this._onDrop);
  }

  disconnect() {
    document.removeEventListener('dragenter', this._onDragEnter);
    document.removeEventListener('dragleave', this._onDragLeave);
    document.removeEventListener('dragover',  this._onDragOver);
    document.removeEventListener('drop',      this._onDrop);

    this.dragCounter = 0;
    this._setDragging(false);
  }

  // ── Document-level drag tracking (counter strategy) ──

  _onDragEnter(event) {
    event.preventDefault();
    this.dragCounter++;
    if (this.dragCounter === 1) this._setDragging(true);
  }

  _onDragLeave(event) {
    event.preventDefault();
    this.dragCounter--;
    if (this.dragCounter <= 0) {
      this.dragCounter = 0;
      this._setDragging(false);
    }
  }

  _onDragOver(event) {
    // Required to allow drop
    event.preventDefault();
  }

  _onDrop(event) {
    // Reset drag state for any drop (even outside the link target)
    this.dragCounter = 0;
    this._setDragging(false);
  }

  // ── Link-level drag actions (wired via data-action on the nav link) ──

  dragOver(event) {
    event.preventDefault();
    if (this.hasLinkTarget) this.linkTarget.classList.add('sidebar-reveal-drag-over');
  }

  dragEnter(event) {
    event.preventDefault();
    if (this.hasLinkTarget) this.linkTarget.classList.add('sidebar-reveal-drag-over');
  }

  dragLeave(event) {
    event.preventDefault();
    if (this.hasLinkTarget) this.linkTarget.classList.remove('sidebar-reveal-drag-over');
  }

  drop(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.hasLinkTarget) this.linkTarget.classList.remove('sidebar-reveal-drag-over');

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) return;

    // Assign dropped file to the hidden file input and trigger form submit
    if (this.hasInputTarget) {
      this.inputTarget.files = files;
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.dragCounter = 0;
    this._setDragging(false);
  }

  // ── Private ──

  _setDragging(active) {
    if (this.hasLinkTarget) {
      this.linkTarget.classList.toggle('sidebar-reveal-dragging', active);
    }
    if (this.hasTextTarget) {
      this.textTarget.textContent = active ? ' Drop here to reveal' : this._originalText;
    }
  }
}

